import './DonateButton.css';

function DonateButton() {
  return (
    <a
      href="https://secure.actblue.com/donate/shield-pac-1"
      className="DonateButton font-extrabold justify-center items-center inline-flex mr-2.5 text-sm tracking-wide text-white uppercase rounded-sm blocky-sm bg-yellow-500"
    >
      Donate
    </a>
  );
}

export default DonateButton;
